import * as React from "react"

import { cn } from "@/lib/utils"

export interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode
  heading: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  iconContainerClassName?: string
}

export function PageHeader({
  className,
  icon,
  heading,
  description,
  actions,
  iconContainerClassName,
  ...props
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center",
        className
      )}
      {...props}
    >
      <div className="flex items-center gap-3 sm:gap-4">
        <div
          className={cn(
            "w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl flex items-center justify-center shrink-0",
            "text-[color:var(--agent-accent)] [&_svg]:w-6 [&_svg]:h-6 sm:[&_svg]:w-8 sm:[&_svg]:h-8",
            iconContainerClassName
          )}
        >
          {icon}
        </div>
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 truncate">{heading}</h1>
          {description ? <div className="text-sm sm:text-base text-gray-500 line-clamp-2">{description}</div> : null}
        </div>
      </div>

      {actions ? <div className="flex gap-2 shrink-0">{actions}</div> : null}
    </div>
  )
}
